"use strict";
var $dyn;
(function ($dyn) {
    Globalize.addCultureInfo("en", {
        messages: {
            TaskGuide_GettingStartedIntroHeader: "Getting Started!",
            TaskGuide_GettingStartedIntroStep: "We're ready to start, are you?",
            TaskGuide_GettingStartedIntroStepInfoButton: "Let's get started!",
            TaskGuide_GettingStartedIntroTitle: "This is the \"Getting started\" pane where you can quickly launch various business processes that we have pre-configured for you.",
            TaskGuide_GettingStartedWelcomeHeader: "Welcome to Dynamics 365 {0}. Try it out!",
            TaskGuide_GettingStartedWelcomeStep: "See how easy it is to manage your business processes with Dynamics 365 {0} using sample data.",
            TaskGuide_GettingStartedWelcomeStepInfoButton: "Dive in !",
            TaskGuide_GettingStartedWelcomeTitle: "Work smarter than ever before with intelligent tools for the modern workplace. Bringing together the best from Microsoft, Microsoft Dynamics 365 {0} enables you to make smarter decisions, redesign business processes faster and fuel business growth.",
            TaskGuide_ShortcutDescriptionCollapse: "Collapse the Task guide dialog box",
            TaskGuide_ShortcutDescriptionExpand: "Expand the Task guide dialog box",
            TaskGuide_ShortcutDescriptionGoToNextStep: "Go to the next step in the Task guide",
            TaskGuide_ShortcutDescriptionGoToPreviousStep: "Go to the previous step in the Task guide",
            TaskGuide_ShortcutDescriptionLock: "Lock the user interface for this Task guide",
            TaskGuide_ShortcutDescriptionShowLess: "Show less information in the Task guide dialog box",
            TaskGuide_ShortcutDescriptionShowMore: "Show more information in the Task guide dialog box",
            TaskGuide_ShortcutDescriptionStopPlayback: "Stop the Task guide",
            TaskGuide_ShortcutDescriptionToggleFocus: "Switch focus between the Task guide dialog box and the page",
            TaskGuide_ShortcutDescriptionUnlock: "Unlock the user interface for this Task guide",
            TaskGuides_VerbalPosition_Down: "Scroll down.",
            TaskGuides_VerbalPosition_Left: "Scroll left.",
            TaskGuides_VerbalPosition_Right: "Scroll right.",
            TaskGuides_VerbalPosition_Up: "Scroll up.",
            TaskRecorder_ShortcutDescriptionShowSteps: "Show the Task guide steps",
            TaskRecorder_ShortcutDescriptionStopRecording: "Stop the Task recorder",
            TaskRecorder_TestMethodNoForm: "Please, navigate to a page and start recording before adding test method",
        }
    });
    var ax;
    (function (ax) {
        var taskGuidesUtil;
        (function (taskGuidesUtil) {
            /**
             * Helper for ScrollComponent
             * Converts the QTip position label to verbal instructions.
             *  @returns Localized instruction for where to scrol
             */
            function qtipPositionToVerbal(positionLabel) {
                var splittedPosition = positionLabel.split(" ");
                var verbalPosition = "";
                if (splittedPosition.length === 2) {
                    // horizontal direction
                    var horizontalDirection = splittedPosition[1];
                    // vertical direction
                    var verticalDirection = splittedPosition[0];
                    // Favor scrolling up or down over left or right.
                    // This will guide users to scoll vertically before scrolling horizontally
                    switch (verticalDirection) {
                        case $dyn.util.VerticalElementVisibility.INVISIBLE_TOP:
                            verbalPosition = $dyn.label("TaskGuides_VerbalPosition_Up");
                            break;
                        case $dyn.util.VerticalElementVisibility.INVISIBLE_BOTTOM:
                            verbalPosition = $dyn.label("TaskGuides_VerbalPosition_Down");
                            break;
                    }
                    switch (horizontalDirection) {
                        case $dyn.util.HorizontalElementVisibility.INVISIBLE_LEFT:
                            verbalPosition = $dyn.label("TaskGuides_VerbalPosition_Left");
                            break;
                        case $dyn.util.HorizontalElementVisibility.INVISIBLE_RIGHT:
                            verbalPosition = $dyn.label("TaskGuides_VerbalPosition_Right");
                            break;
                    }
                }
                return verbalPosition;
            }
            taskGuidesUtil.qtipPositionToVerbal = qtipPositionToVerbal;
            /**
             * Helper for ScrollComponent
             * Checks if the target is currently visible within the container.
             */
            function elementsHaveCommonSpace(targetRect, containerRect) {
                var horizontalVisibility = $dyn.util.elementHorizontalVisibilityInParentContainer(targetRect, containerRect);
                var verticalVisibility = $dyn.util.elementVerticalVisibilityInParentContainer(targetRect, containerRect);
                if ((horizontalVisibility === $dyn.util.HorizontalElementVisibility.PARTIAL || horizontalVisibility === $dyn.util.HorizontalElementVisibility.VISIBLE) &&
                    (verticalVisibility === $dyn.util.VerticalElementVisibility.PARTIAL || verticalVisibility === $dyn.util.VerticalElementVisibility.VISIBLE)) {
                    return true;
                }
                return false;
            }
            taskGuidesUtil.elementsHaveCommonSpace = elementsHaveCommonSpace;
            /**
             * Helper for ScrollComponent
             * If the target is currently visible within the container, get the area defined by their overlap.
             * @returns Null if not overlapping
             */
            function visibleAreaInContainerElement(targetRect, containerRect) {
                if (!targetRect || !containerRect) {
                    return null;
                }
                if (!$dyn.ax.taskGuidesUtil.elementsHaveCommonSpace(targetRect, containerRect)) {
                    return null;
                }
                var visibleRect = jQuery.extend(true, {}, targetRect);
                // Horizontal
                if (targetRect.left < containerRect.left) {
                    visibleRect.left = containerRect.left;
                }
                if (targetRect.right > containerRect.right) {
                    visibleRect.right = containerRect.right;
                }
                // Vertical
                if (targetRect.top < containerRect.top) {
                    visibleRect.top = containerRect.top;
                }
                if (targetRect.bottom > containerRect.bottom) {
                    visibleRect.bottom = containerRect.bottom;
                }
                return visibleRect;
            }
            taskGuidesUtil.visibleAreaInContainerElement = visibleAreaInContainerElement;
            /**
             * Helper for ScrollComponent
             * Checks the visibility data for nested elements.
             * @returns Null if no elements.
             */
            function visibilityDataForNestedElements(nestedElements) {
                // Assumption: first element is the deepest child among nested elements
                if (nestedElements.length <= 0) {
                    return null;
                }
                var visibilityData = [];
                // Top most parent is always visible
                var $prevElement = nestedElements[nestedElements.length - 1];
                var prevElementRect = $dyn.util.elementRectangle($prevElement);
                var prevElementVisibilityData = new $dyn.ax.taskGuidesUtil.VisibilityData({
                    $element: $prevElement,
                    elementRect: prevElementRect,
                    horizontalVisibility: $dyn.util.HorizontalElementVisibility.VISIBLE,
                    verticalVisibility: $dyn.util.VerticalElementVisibility.VISIBLE,
                    visibleArea: prevElementRect
                });
                visibilityData.unshift(prevElementVisibilityData);
                for (var i = nestedElements.length - 2; i >= 0; --i) {
                    var $currentElement = nestedElements[i];
                    var currentElementRect = $dyn.util.elementRectangle($currentElement);
                    var horizontalVisibility = $dyn.util.elementHorizontalVisibilityInParentContainer(currentElementRect, prevElementVisibilityData.visibleArea);
                    var verticalVisibility = $dyn.util.elementVerticalVisibilityInParentContainer(currentElementRect, prevElementVisibilityData.visibleArea);
                    var currentVisibilityData = new $dyn.ax.taskGuidesUtil.VisibilityData({
                        $element: $currentElement,
                        elementRect: currentElementRect,
                        horizontalVisibility: horizontalVisibility,
                        verticalVisibility: verticalVisibility,
                    });
                    var elementVisibleArea = null;
                    if (currentVisibilityData.isPartiallyVisible()) {
                        elementVisibleArea = $dyn.ax.taskGuidesUtil.visibleAreaInContainerElement(currentElementRect, prevElementVisibilityData.visibleArea);
                    }
                    currentVisibilityData.visibleArea = elementVisibleArea;
                    $prevElement = $currentElement;
                    prevElementVisibilityData = currentVisibilityData;
                    visibilityData.unshift(currentVisibilityData);
                }
                return visibilityData;
            }
            taskGuidesUtil.visibilityDataForNestedElements = visibilityDataForNestedElements;
        })(taskGuidesUtil = ax.taskGuidesUtil || (ax.taskGuidesUtil = {}));
    })(ax = $dyn.ax || ($dyn.ax = {}));
    var taskRecorderShortCuts = {
        TaskGuideNextStepButton: {
            ChordKeys: { alt: true, keyCode: $dyn.ui.KeyCodes.letterR },
            Description: $dyn.label("TaskGuide_ShortcutDescriptionGoToNextStep"),
            Handler: function () {
                if ($dyn.value($dyn.ax.taskRecording.taskGuidePlaybackState)) {
                    if ($dyn.value($dyn.ax.taskRecording.taskRecorderController.NextButtonVisible)) {
                        $dyn.ax.taskRecording.taskRecorderController.SkipGuidedStep();
                    }
                }
            },
            Keys: { keyCode: $dyn.ui.KeyCodes.letterN },
            ShowToUser: function () {
                return $dyn.value($dyn.ax.taskRecording.taskGuidePlaybackState);
            },
        },
        TaskGuidePreviousStepButton: {
            ChordKeys: { alt: true, keyCode: $dyn.ui.KeyCodes.letterR },
            Description: $dyn.label("TaskGuide_ShortcutDescriptionGoToPreviousStep"),
            Handler: function () {
                if ($dyn.value($dyn.ax.taskRecording.taskGuidePlaybackState)) {
                    if ($dyn.value($dyn.ax.taskRecording.taskRecorderController.BackButtonVisible)) {
                        $dyn.ax.taskRecording.taskRecorderController.SkipBackGuidedStep();
                    }
                }
            },
            Keys: { keyCode: $dyn.ui.KeyCodes.letterP },
            ShowToUser: function () {
                return $dyn.value($dyn.ax.taskRecording.taskGuidePlaybackState);
            },
        },
        TaskRecorderOpenPane: {
            ChordKeys: { alt: true, keyCode: $dyn.ui.KeyCodes.letterR },
            Description: $dyn.label("TaskRecorder_ShortcutDescriptionShowSteps"),
            Handler: function () {
                if ($dyn.value($dyn.ax.taskRecording.taskGuidePlaybackState)) {
                    $dyn.ax.taskRecording.toggleTaskGuidePaneVisibility();
                }
                else if ($dyn.value($dyn.ax.taskRecording.isRecording)) {
                    $dyn.ax.taskRecording.toggleTaskPaneVisibility();
                }
            },
            Keys: { keyCode: $dyn.ui.KeyCodes.letterT },
            ShowToUser: function () {
                return $dyn.value($dyn.ax.taskRecording.isRecording);
            },
        },
        TaskRecorderStop: {
            ChordKeys: { alt: true, keyCode: $dyn.ui.KeyCodes.letterR },
            Description: function () {
                return $dyn.value($dyn.ax.taskRecording.taskGuidePlaybackState) ?
                    $dyn.label("TaskGuide_ShortcutDescriptionStopPlayback") : $dyn.label("TaskRecorder_ShortcutDescriptionStopRecording");
            },
            Handler: function () {
                if ($dyn.value($dyn.ax.taskRecording.isRecording)) {
                    $dyn.ax.taskRecording.stopSession();
                }
            },
            Keys: { keyCode: $dyn.ui.KeyCodes.letterS },
            ShowToUser: function () {
                return $dyn.value($dyn.ax.taskRecording.taskGuidePlaybackState) || $dyn.value($dyn.ax.taskRecording.isRecording);
            },
        },
        TaskRecorderToggleRailsMode: {
            ChordKeys: { alt: true, keyCode: $dyn.ui.KeyCodes.letterR },
            Description: function () {
                return $dyn.value($dyn.ax.taskRecording.taskGuideRailsMode) ? $dyn.label("TaskGuide_ShortcutDescriptionUnlock") : $dyn.label("TaskGuide_ShortcutDescriptionLock");
            },
            Handler: function () {
                if ($dyn.value($dyn.ax.taskRecording.taskGuidePlaybackState)) {
                    if ($dyn.value($dyn.ax.taskRecording.taskGuideRailsMode)) {
                        $dyn.ax.taskRecording.SwitchRailsModeOff();
                    }
                    else {
                        $dyn.ax.taskRecording.SwitchRailsModeOn();
                    }
                }
            },
            Keys: { keyCode: $dyn.ui.KeyCodes.letterL },
            ShowToUser: function () {
                return $dyn.value($dyn.ax.taskRecording.taskGuidePlaybackState);
            }
        },
        ToggleTaskGuideExpandCollapse: {
            ChordKeys: { alt: true, keyCode: $dyn.ui.KeyCodes.letterR },
            Description: function () {
                return $dyn.value($dyn.ax.taskRecording.taskRecorderController.GuidedStepVisible) ? $dyn.label("TaskGuide_ShortcutDescriptionCollapse") : $dyn.label("TaskGuide_ShortcutDescriptionExpand");
            },
            Handler: function () {
                if ($dyn.value($dyn.ax.taskRecording.taskGuidePlaybackState)) {
                    $dyn.ax.taskRecording.taskRecorderController.ToggleGuidedStep();
                }
            },
            Keys: { keyCode: $dyn.ui.KeyCodes.letterC },
            ShowToUser: function () {
                return $dyn.value($dyn.ax.taskRecording.taskGuidePlaybackState);
            }
        },
        ToggleTaskGuideFocus: {
            ChordKeys: { alt: true, keyCode: $dyn.ui.KeyCodes.letterR },
            Description: $dyn.label("TaskGuide_ShortcutDescriptionToggleFocus"),
            Handler: function () {
                var elem = document.querySelector(".taskGuideStep");
                if (elem) {
                    if (elem.contains(document.activeElement)) {
                        var form = $dyn.context($dyn.shell.getActiveForm());
                        if (form) {
                            $dyn.log.focus && $dyn.log.focus("Focus: Shell->Shortcuts(ToggleTaskGuideFocus) return focus to form Id: %s calling takeNavigationFocus", form.Id);
                            form.takeNavigationFocus();
                        }
                    }
                    else {
                        $dyn.log.focus && $dyn.log.focus("Focus: Shell->Shortcuts(ToggleTaskGuideFocus) focus task guide qtip");
                        var firstControlElement = $dyn.util.findFirstFocusableControl(elem);
                        if (firstControlElement) {
                            firstControlElement.focus();
                        }
                    }
                }
            },
            Keys: { keyCode: $dyn.ui.KeyCodes.letterF },
            ShowToUser: function () {
                return $dyn.value($dyn.ax.taskRecording.taskGuidePlaybackState);
            }
        },
        ToggleTaskGuideShowMore: {
            ChordKeys: { alt: true, keyCode: $dyn.ui.KeyCodes.letterR },
            Description: function () {
                return $dyn.value($dyn.ax.taskRecording.taskRecorderController.DetailsGroupVisibilityToggled) ? $dyn.label("TaskGuide_ShortcutDescriptionShowLess") : $dyn.label("TaskGuide_ShortcutDescriptionShowMore");
            },
            Handler: function () {
                if ($dyn.value($dyn.ax.taskRecording.taskGuidePlaybackState)) {
                    $dyn.ax.taskRecording.taskRecorderController.ToggleDetails();
                }
            },
            Keys: { keyCode: $dyn.ui.KeyCodes.letterM },
            ShowToUser: function () {
                return $dyn.value($dyn.ax.taskRecording.taskGuidePlaybackState);
            }
        }
    };
    $dyn.shell.Shortcuts = $dyn.extendPrototype($dyn.shell.Shortcuts, taskRecorderShortCuts);
})($dyn || ($dyn = {}));

//# sourceMappingURL=TaskGuidesUtil.js.map
